import { useSearchParams } from '../navigation';

export default function useQuery() {
  return useSearchParams();
}
